var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-skeleton',{staticStyle:{"width":"80%","height":"20px"},attrs:{"animated":""}},[_c('template',{slot:"template"},[_c('el-skeleton-item',{staticStyle:{"width":"80%","height":"20px"},attrs:{"variant":"rect"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }